import { useEffect, useState } from 'react';
import { db } from '@/lib/firebase';
import { doc, getDoc } from 'firebase/firestore';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import FloatingButtons from '@/components/feature/FloatingButtons';
import AboutHero from './components/AboutHero';
import BrandStory from './components/BrandStory';
import WhyBucara from './components/WhyBucara';
import OurExperience from './components/OurExperience';
import AboutCTA from './components/AboutCTA';

export default function AboutPage() {
  const [images, setImages] = useState<any>({});

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'About Us | Bucara Burger – Colombian Food Truck in Boise, Idaho';

    const fetchImages = async () => {
      try {
        const docSnap = await getDoc(doc(db, 'settings', 'landing_images'));
        if (docSnap.exists()) {
          setImages(docSnap.data());
        }
      } catch (error) {
        console.error("Error fetching about images:", error);
      }
    };
    fetchImages();
  }, []);

  return (
    <div className="bg-black min-h-screen">
      <Navbar />
      <main>
        <AboutHero image={images?.aboutHeroImage} />
        <BrandStory image={images?.aboutStoryImage} />
        <WhyBucara images={[
          images?.aboutWhy1Image,
          images?.aboutWhy2Image,
          images?.aboutWhy3Image,
          images?.aboutWhy4Image,
        ]} />
        <OurExperience />
        <AboutCTA image={images?.aboutCTAImage} />
      </main>
      <Footer />
      <FloatingButtons />
    </div>
  );
}
